export default "__VITE_ASSET__Blkgsgrh__"